<template>

    <div class="box-offset">
        <div class="box-ttl">Time sheet</div>
        <div class="buttons--row justify-content-end mb-4">
            <div class="filter-wrap">
                <label for="" class="reg-label mr-2">Filter:</label>
                <div class="form-group form-group-2 mb-0">
                    <select
                        class="custom-select"
                        v-model="filters.filter"
                        @change="getListOfPeriods(filters)"
                    >
                        <option value="all" selected="">Select One</option>
                        <option
                            v-for="year in years"
                            :key="year"
                            :value="year"
                        >
                            {{ year }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="table-holder table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th >
                        <nobr>Choose Pay Period</nobr>
                    </th>
                    <th class="text-center">New Timesheets</th>
                    <th class="text-center">Needs Attention</th>
                    <th class="text-center">Approved</th>
                    <th class="text-center">Total</th>
                    <th class="text-right pr-3">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    class="clickable-row"
                    v-for="period in periods"
                    :key="period.id"
                >
                    <td>
                        <a
                            :href="`/master-admin/timesheets/periods/${period.id}/timesheets?period=${period.id}`"
                            class="mr-2"
                        >
                            <nobr><b>{{ dateForTimeSheets(period.start_date) }} - {{ dateForTimeSheets(period.end_date) }}</b></nobr></a>
                    </td>
                    <td class="text-center">
                       {{period.new_timesheets}}
                    </td>
                    <td class="text-center">
                        {{period.needs_attention_timesheets }}
                    </td>
                    <td class="text-center">{{period.approved_timesheets}}</td>
                    <td class="text-center">{{ period.new_timesheets + period.needs_attention_timesheets + period.approved_timesheets }} </td>
                    <td class="text-right pr-4">
                        <div class="action-block" v-if="period.isLocked">
                            <div class="img-btn"><img src="/img/svg/icons-lock.svg" alt=""></div>
                        </div>
                        <div class="action-block" v-else>
                            <a
                                href="javascript:void(0)"
                                @click="showDeleteModal(period.id)"
                            >
                                Lock
                            </a>
                            <ActionModal confirm-text="Proceed" reject-text="Cancel"
                                         :modalId="getDeleteModalId(period.id)"
                                         @confirm="closePeriod(period.id)">
                                <template #body>
                                    <div class="text-center mb-4">
                                        <h4>
                                            Are you sure that you would like to<br>
                                            lock this pay period?
                                        </h4>
                                        <p>This action can not be undone.</p>
                                    </div>
                                </template>
                            </ActionModal>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <Pagination
            :currentPage="pagination.current_page"
            :lastPage="pagination.last_page"
            @changeItemsPerPage="changeItemsPerPage"
            @changePage="changePage"/>
    </div>

</template>


<script>
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import TimeSheetService from "./services/TimeSheetService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";

export default {
    name: 'ListOfPeriods',
    components: {ActionModal, Pagination},
    mixins: [ ModalHandler, PaginationHandler, DateConverter],
    data() {
        return {
            selectedYear: new Date().getFullYear(),
            startYear: 2023,
            periods: [],
            filters: {
                filter: 'all',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    computed: {
        years() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = this.startYear; year <= currentYear; year++) {
                years.push(year);
            }
            return years;
        },
    },
    methods: {
        getList(filters) {
            this.getListOfPeriods(filters)
        },
        async closePeriod(id) {
            this.$showLoadingMessage()
            try {
                await TimeSheetService.lockPeriod(id)
                await this.getListOfPeriods()
                this.$showSuccessMessage('Period is locked!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('This period was not locked. Please try again.')
            }
        },
        async getListOfPeriods() {
            try {
                const {data: response} = await TimeSheetService.getPeriods(this.filters)
                this.periods = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
            } catch (e) {
                console.error(e)
            }
        },
    },
    mounted() {
        this.getListOfPeriods()
    }

}

</script>


<style scoped>

</style>
